import { IAuthProvider } from './authProvider';

export interface IResource {
  id: number;
  type: string;
  authProvider: IAuthProvider;
}
